var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 42C28.5667 42 29.0417 41.8083 29.425 41.425C29.8083 41.0417 30 40.5667 30 40C30 39.4333 29.8083 38.9583 29.425 38.575C29.0417 38.1917 28.5667 38 28 38C27.4333 38 26.9583 38.1917 26.575 38.575C26.1917 38.9583 26 39.4333 26 40C26 40.5667 26.1917 41.0417 26.575 41.425C26.9583 41.8083 27.4333 42 28 42ZM40 22C40.5667 22 41.0417 21.8083 41.425 21.425C41.8083 21.0417 42 20.5667 42 20C42 19.4333 41.8083 18.9583 41.425 18.575C41.0417 18.1917 40.5667 18 40 18C39.4333 18 38.9583 18.1917 38.575 18.575C38.1917 18.9583 38 19.4333 38 20C38 20.5667 38.1917 21.0417 38.575 21.425C38.9583 21.8083 39.4333 22 40 22ZM12 22H22V18H12V22ZM12 30H22V26H12V30ZM8 40C6.9 40 5.95833 39.6083 5.175 38.825C4.39167 38.0417 4 37.1 4 36V12C4 10.9 4.39167 9.95833 5.175 9.175C5.95833 8.39167 6.9 8 8 8H40C41.1 8 42.0417 8.39167 42.825 9.175C43.6083 9.95833 44 10.9 44 12H8V36H18V40H8ZM28 46C26.3333 46 24.9167 45.4167 23.75 44.25C22.5833 43.0833 22 41.6667 22 40C22 38.7 22.375 37.5333 23.125 36.5C23.875 35.4667 24.8333 34.75 26 34.35V28H38V25.65C36.8333 25.25 35.875 24.5333 35.125 23.5C34.375 22.4667 34 21.3 34 20C34 18.3333 34.5833 16.9167 35.75 15.75C36.9167 14.5833 38.3333 14 40 14C41.6667 14 43.0833 14.5833 44.25 15.75C45.4167 16.9167 46 18.3333 46 20C46 21.3 45.625 22.4667 44.875 23.5C44.125 24.5333 43.1667 25.25 42 25.65V32H30V34.35C31.1667 34.75 32.125 35.4667 32.875 36.5C33.625 37.5333 34 38.7 34 40C34 41.6667 33.4167 43.0833 32.25 44.25C31.0833 45.4167 29.6667 46 28 46Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowsheet);
export default __webpack_public_path__ + "static/media/flowsheet.2b6d2cc3a426d8479b4c32ef62d455d3.svg";
export { ForwardRef as ReactComponent };